export default __webpack_public_path__ + "assets/logos/smartway-logo.9300fd28decf7993a2693696159364cf.jpg";